import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"
import CustomBgImage from "../../components/custom-bg-image/custom-bg-image.component"
import BackgroundPattern from "../../components/background-pattern/background-pattern.component"

export const Section = styled(SectionWrapper)`
  padding-top: 0;
  padding-bottom: 0;
  position: relative;
`

export const BackgroundImage = styled(BackgroundPattern)`
  /* position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  img {
    height: 100%;
    object-fit: cover !important;
  } */
`

export const GroupContainer = styled.div``
